export const typedObjectKeys = <T>(o: T): (keyof T)[] => {
  const keys: (keyof T)[] = []

  let k: keyof T
  for (k in o) {
    keys.push(k)
  }
  return keys
}
